import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import api from '../services/api'; // pastikan ada method api.getAllGaleri()

const Galeri = () => {
  const [galeri, setGaleri] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchGaleri = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.getGaleri();
      setGaleri(response);
    } catch (err) {
      setError('Gagal memuat data galeri');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGaleri();
  }, []);

  return (
    <>
      <Navbar />
      <main className="w-full px-4 lg:px-8 py-6">
        <h2 className="text-center text-2xl font-bold mb-6">Galeri Kegiatan</h2>
        
        {error && <p className="text-center text-red-500 mb-4">{error}</p>}
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {galeri.map((item) => (
              <div key={item.id} className="bg-white shadow-lg rounded-lg overflow-hidden">
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}/public/upload/${item.gambar.filename}`}
                  alt={item.judul}
                  className="w-full h-48 object-cover"
                />
                <p className="p-4 text-center text-gray-700">{item.judul}</p>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default Galeri;
